import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { NavMenu } from "../components/nav-menu.component";
import { SideMenu } from "../components/side-menu.component";
import authService from "../services/auth.service";
import MemberCadastre from "./cadastres/member.cadastre";
import PartnerCadastre from "./cadastres/partner.cadastre";
import ShipCadastre from "./cadastres/vessel.cadastre";
import DashboardPage from "./dashboards/dashboard";
import MonitoringDashboard from "./dashboards/monitoring.dashboard";
import MovementDashboard from "./dashboards/movement.dashboard";
import ErrorPage from "./error.page";
import ConciliationsFinancial from "./financial/conciliations.financial";
import ContractLauchersFinancial from "./financial/launchers.financial";
import ContratctsFinancial from "./financial/contratcts.financial";
import MovementsOperation from "./operations/movements.operation";
import ProfilePage from "./others/profile.page";
import SettingsPage from "./others/settings.page";
import KeepBoatsOperation from "./operations/keep-boats.operation";
import CategoryCadastre from "./cadastres/category.cadastre";
import PurveyorCadastre from "./cadastres/purveyor.cadastre";
import MechanicCadastre from "./cadastres/mechanic.cadastre";
import ProductCadastre from "./cadastres/product.cadastre";
import BudgetOffice from "./offices/budget.office";
import ScheduleOffice from "./offices/schedule.office";
import MenuAccessPage from "./others/menu-access.page";
import UserAccessPage from "./others/user-access.page";
import ContractManagementFinancial from "./financial/ContractManagementFinancial";
import MovementsHistoryOperation from "./operations/movement-history.operation";
import AssessmentsOperation from "./operations/assessments.operation";
import ContractCustomerFinancial from "./financial/contract-customer.financial";
import EmployeeCadastre from "./cadastres/employee.cadastre";
import ServiceCenterDashboard from "./dashboards/ServiceCenterDashboard";
import HourlyOccupation from "./dashboards/HourlyOccupation";
import HourlyPrediction from "./dashboards/HourlyPrediction";
import StockDashboard from "./dashboards/StockDashboard";
import StockSearch from "./stock/StockSearch";
import OperationManagement from "./dashboards/OperationManagement";
import Reservation from "./dashboards/Reservation";
import SharingManagementDashboard from "./dashboards/SharingManagementDashboard";
import DeliveryManagementDashboard from "./dashboards/DeliveryManagementDashboard";
import DeliveryMovementDashboard from "./dashboards/DeliveryMovementDashboard";
import CustomizeDashboard from "./dashboards/CustomizeDashboard";
import { useMediaContext } from "../contexts/media.context";
import { usePartnerContext } from "../contexts/partner.context";
import { isEmpty } from "../utilities/validators";
import MaritimeDashboard from "./dashboards/MaritimeDashboard";
import FinancialDashboard from "./dashboards/FinancialDashboard";
import CleaningProvided from "./provideds/CleaningProvided";
import CleaningDashboard from "./dashboards/CleaningDashboard";
import { CondominiumManagementDashboard } from "./dashboards/CondominiumDashboard";
import RewardsManagementDashboard from "./dashboards/RewardsManagementDashboard";
import BenefitCadastre from "./cadastres/benefit.cadastre";
import RulesBenefit from "./benefit/rules.benefit";
import EncounterCondominium from "./condominium/encounter.condominium";
import CommonAreaCondominium from "./condominium/common-area.condominium";
import ServantCondominium from "./condominium/servant.condominium";
import EstateCondominium from "./condominium/estate.condominium";
import ResidentCondominium from "./condominium/resident.condominium";
import VisitorCondominium from "./condominium/visitor.condominium";
import VehicleCondominium from "./condominium/vehicle.condominium";
import VesselCondominium from "./condominium/vessel.condominium";
import PendencyCondominium from "./condominium/pendency.condominium";
import InfractionCondominium from "./condominium/infraction.condominium";
import ReservationCondominium from "./condominium/reservation.condominium";
import NotificationCondominium from "./condominium/notification.condominium";
import NoticeCondominium from "./condominium/notice.condominium";
import OccurrenceCondominium from "./condominium/occurrence.condominium";
import LostAndFoundCondominium from "./condominium/lost-and-found.condominium";
import DeliveryOperation from "./operations/delivery.operation";
import EstateCondominiumList from "./condominium/lists/estate.condominium.list";
import { useTranslateContext } from "../contexts/translate.context";
import EstateCondominiumForm from "./condominium/forms/estate.condominium.form";
import HouseCondominiumForm, { EstateAllCondominiumForm } from "./condominium/forms/estate-all-condominium-form";
import DRE from "./financial/dre";

export interface IPortalPageProps {
}

export const PortalPage: React.FC<IPortalPageProps> = (props: IPortalPageProps) => {
   
    const { changeMedia } = useMediaContext();
    const { partner, setPartner } =  usePartnerContext();
    const { display } = useTranslateContext();

    const isDashboard = (window.location.pathname.indexOf('dashboard') > -1);
    const isSetting = (window.location.pathname.indexOf('settings') > -1);
    const [ inactive, setInactive ] = useState(isDashboard || isSetting);
    
    const [ showVideo, setShowVideo ] = useState({ show: false, video: undefined });

    function onClickBrand_Click(event: any) {
        setInactive(!inactive);
    }

    function onClick_Logout(event: any) {
        event.preventDefault();

        authService.logout();
        window.location.href = '/';
    }

    function onMouseDown(event: any) {
        authService.validToken(true);
    }

    function onResize(event: any) {
        changeMedia();
    }

    useEffect(() => {
        if (isEmpty(partner)) {
            setPartner(authService.currentPartner());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partner]);

    useEffect(() => {
        window.addEventListener("resize", onResize);
    });

    return (
        <>
            <div className="portal" onMouseDown={ e => onMouseDown(e) }>
                {!authService.isAssociateOperator() && (
                    <SideMenu
                        /* 
                        smooth={smooth}
                        name={userData.name} 
                        profile={userData.profile} 
                        email={userData.email} 
                        telephone={userData.telephone}
                        partner={userData.partner}
                        onChangeProfile={(value: any) => {
                            setViewProfile(value);
                        }}
                        */
                        onCollapse={inactive}
                        onCloseSideMenu={(value: any) => {
                            setInactive(value);
                        }}
                        onSignout={onClick_Logout}
                        showVideo={showVideo}
                        setShowVideo={setShowVideo}
                    />
                )}
                <div className="main">
                    <NavMenu onBrandClick={ (e: any) => onClickBrand_Click(e) } onClickSair={ (e: any) => onClick_Logout(e) } onCloseSideMenu={(value: any) => {
                        setInactive(value);
                    }} setShowVideo={setShowVideo} />
                    <Routes>
                        <Route index element={<DashboardPage />} />

                        <Route path='/profile' element={<ProfilePage />} />
                        <Route path='/settings' element={<SettingsPage />} />
                        <Route path='/menu_access' element={<MenuAccessPage />} />
                        <Route path='/user_access' element={<UserAccessPage />} />
                        
                        {authService.isAssociateOperator() ? (
                            <>
                                <Route path='/dashboard/operation-management' element={<OperationManagement />} />
                                <Route path='/dashboard/operation-management/:reservation' element={<Reservation />} />
                            </>
                        ) : (
                            <>
                                <Route path='/dashboard/customize' element={<CustomizeDashboard />} />

                                <Route path='/dashboard/maritime' element={<MaritimeDashboard />} />
                                <Route path='/dashboard/financial' element={<FinancialDashboard />} />
                                <Route path='/dashboard/cleaning' element={<CleaningDashboard />} />
                                <Route path='/dashboard/stock' element={<StockDashboard />} />
                                <Route path='/dashboard/sharing' element={<SharingManagementDashboard />} />
                                <Route path='/dashboard/service-center' element={<ServiceCenterDashboard />} />
                                <Route path='/dashboard/delivery' element={<DeliveryManagementDashboard />} />
                                <Route path='/dashboard/hourly-occupation' element={<HourlyOccupation />} />
                                <Route path='/dashboard/hourly-prediction' element={<HourlyPrediction />} />
                                                                
                                <Route path='/dashboard/movement' element={<MovementDashboard />} />
                                <Route path='/dashboard/monitoring' element={<MonitoringDashboard />} />
                                <Route path='/dashboard/operation-management' element={<OperationManagement />} />
                                <Route path='/dashboard/operation-management/:reservation' element={<Reservation />} />

                                <Route path='/dashboard/condominium' element={<CondominiumManagementDashboard />} />
                                <Route path='/dashboard/rewards' element={<RewardsManagementDashboard />} />

                                <Route path='/dashboard/movement-delivery' element={<DeliveryMovementDashboard />} />

                                <Route path='/provideds/cleaning' element={<CleaningProvided />} />

                                {/* CADASTRE */}
                                <Route path='/cadastre/category' element={<CategoryCadastre />}>
                                    <Route path='/cadastre/category/:categoryId' element={<CategoryCadastre />} />
                                </Route>
                                <Route path='/cadastre/member' element={<MemberCadastre />}>
                                    <Route path='/cadastre/member/:memberId' element={<MemberCadastre />} />
                                </Route>
                                <Route path='/cadastre/partner' element={<PartnerCadastre />}>
                                    <Route path='/cadastre/partner/:partnerId' element={<PartnerCadastre />} />
                                </Route>
                                <Route path='/cadastre/benefit' element={<BenefitCadastre />}>
                                    <Route path='/cadastre/benefit/:benefitId' element={<BenefitCadastre />} />
                                </Route>

                                <Route path='/cadastre/vessel' element={<ShipCadastre />}>
                                    <Route path='/cadastre/vessel/:vesselId' element={<ShipCadastre />} />
                                </Route>
                                <Route path='/cadastre/purveyor' element={<PurveyorCadastre />}>
                                    <Route path='/cadastre/purveyor/:purveyorId' element={<PurveyorCadastre />} />
                                </Route>
                                <Route path='/cadastre/employee' element={<EmployeeCadastre />}>
                                    <Route path='/cadastre/employee/:employeeId' element={<EmployeeCadastre />} />
                                </Route>
                                <Route path='/cadastre/mechanic' element={<MechanicCadastre />}>
                                    <Route path='/cadastre/mechanic/:mechanicId' element={<MechanicCadastre />} />
                                </Route>
                                <Route path='/cadastre/product' element={<ProductCadastre />}>
                                    <Route path='/cadastre/product/:productId' element={<ProductCadastre />} />
                                </Route>

                                {/* INICIO Menus apenas de visualizações */}
                                <Route path='/member' element={<MemberCadastre viewOnly={true} />}>
                                    <Route path='/member/:memberId' element={<MemberCadastre viewOnly={true} />} />
                                </Route>
                                <Route path='/vessel' element={<ShipCadastre viewOnly={true} />}>
                                    <Route path='/vessel/:vesselId' element={<ShipCadastre viewOnly={true} />} />
                                </Route>
                                <Route path='/employee' element={<EmployeeCadastre viewOnly={true} />}>
                                    <Route path='/employee/:employeeId' element={<EmployeeCadastre viewOnly={true} />} />
                                </Route>
                                <Route path='/mechanic' element={<MechanicCadastre viewOnly={true} />}>
                                    <Route path='/mechanic/:mechanicId' element={<MechanicCadastre viewOnly={true} />} />
                                </Route>
                                <Route path='/product' element={<ProductCadastre viewOnly={true} />}>
                                    <Route path='/product/:productId' element={<ProductCadastre viewOnly={true} />} />
                                </Route>
                                {/* FIM */}
                                <Route path='/delivery' element={<DeliveryOperation />} />

                                <Route path='/condominium/register/estate' element={<EstateAllCondominiumForm title={display.title.estate} identifier='new' tabView={'estate-vessel'} />} />

                                <Route path='/condominium/consultation/estate' element={<EstateCondominium />} />
                                <Route path='/condominium/consultation/resident' element={<ResidentCondominium />} />
                                <Route path='/condominium/consultation/visitor' element={<VisitorCondominium />} />
                                <Route path='/condominium/consultation/vehicle' element={<VehicleCondominium />} />
                                <Route path='/condominium/consultation/vessel' element={<VesselCondominium />} />
                                <Route path='/condominium/consultation/servant' element={<ServantCondominium />} />

                                <Route path='/condominium/notices' element={<NoticeCondominium />} />
                                <Route path='/condominium/common-areas' element={<CommonAreaCondominium />} />

                                <Route path='/condominium/occurrences/notification' element={<NotificationCondominium />} />
                                <Route path='/condominium/occurrences/infringement' element={<InfractionCondominium />} />

                                <Route path='/condominium/assemblies' element={<EncounterCondominium />} />
                                <Route path='/condominium/meetings' element={<EncounterCondominium />} />
                                <Route path='/condominium/lost-and-found' element={<LostAndFoundCondominium />} />

                                {/*
                                <Route path='/condominium/pendencies' element={<PendencyCondominium />} />
                                <Route path='/condominium/reservations' element={<ReservationCondominium />} />
                                <Route path='/condominium/occurrences' element={<OccurrenceCondominium />} />
                                */}
                                <Route path='/benefit/rules' element={<RulesBenefit />} />
                                <Route path='/schedule' element={<ScheduleOffice />}>
                                    <Route path='/schedule/:scheduleId' element={<ScheduleOffice />} />
                                </Route>

                                <Route path='/stock/search' element={<StockSearch />} />

                                <Route path='/operation/movement' element={<MovementsOperation />}>
                                    <Route path='/operation/movement/:movementId' element={<MovementsOperation />} />
                                </Route>
                                <Route path='/operation/movement-history' element={<MovementsHistoryOperation />}>
                                    <Route path='/operation/movement-history/:movementHistoryId' element={<MovementsHistoryOperation />} />
                                </Route>
                                <Route path='/operation/keep_boat' element={<KeepBoatsOperation />}>
                                    <Route path='/operation/keep_boat/:bookcaseId' element={<KeepBoatsOperation />} />
                                </Route>
                                <Route path='/operation/assessment' element={<AssessmentsOperation />}>
                                    <Route path='/operation/assessment/:assessmentId' element={<AssessmentsOperation />} />
                                </Route>
                                
                                <Route path='/office/budget' element={<BudgetOffice />}>
                                    <Route path='/office/budget/:budgetId' element={<BudgetOffice />} />
                                </Route>

                                <Route path='/financial/dre' element={<DRE />} />
                                <Route path='/financial/contract' element={<ContratctsFinancial />}>
                                    <Route path='/financial/contract/:contractId' element={<ContratctsFinancial />} />
                                </Route>
                                <Route path='/financial/launcher' element={<ContractLauchersFinancial />}>
                                    <Route path='/financial/launcher/:launcherId' element={<ContractLauchersFinancial />} />
                                </Route>
                                <Route path='/financial/contract-management' element={<ContractManagementFinancial />}>
                                    <Route path='/financial/contract-management/:contractId' element={<ContractManagementFinancial />} />
                                </Route>
                                <Route path='/financial/contract-customer' element={<ContractCustomerFinancial />}>
                                    <Route path='/financial/contract-customer/:contractId' element={<ContractCustomerFinancial />} />
                                </Route>
                                <Route path='/financial/conciliation' element={<ConciliationsFinancial />}>
                                    <Route path='/financial/conciliation/:conciliationId' element={<ConciliationsFinancial />} />
                                </Route>
                            </>
                        )}
                        <Route path="*" element={<ErrorPage type={'Não mapeado em Portal'} />} />
                    </Routes>
                </div>
            </div>
        </>
    )
}

export default PortalPage;
